import React from 'react';
import { Home, Briefcase, Factory, Wheat, Key } from 'lucide-react'; 
import './PropertyTypes.css';

const PROPERTY_DATA = [
  {
    id: 1,
    category: "Residential",
    details: "Flats, Villas, Plots, Farmhouses",
    // HD Modern Villa
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1200&q=80", 
    icon: <Home size={28} />,
    description: "Curated living spaces designed for comfort and legacy building."
  },
  {
    id: 2,
    category: "Commercial",
    details: "Offices, Shops, Showrooms",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80", // Glass Office
    icon: <Briefcase size={28} />,
    description: "Strategic high-value spaces for business growth and visibility."
  },
  {
    id: 3,
    category: "Agricultural",
    details: "Farmlands, Plantations",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=80", // Green Fields
    icon: <Wheat size={28} />,
    description: "Secure investments in nature with high appreciation potential."
  },
  {
    id: 4,
    category: "Industrial",
    details: "Warehouses, Factories",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80", // Modern Warehouse
    icon: <Factory size={28} />,
    description: "Robust infrastructure solutions for manufacturing and logistics."
  },
  {
    id: 5,
    category: "Rental & Income",
    details: "PGs, Leased Spaces",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80", // Modern Apartment Interior
    icon: <Key size={28} />,
    description: "Passive income generating assets with steady rental yields."
  }
];

const PropertyTypes = () => {
  return (
    <section className="property-section" id="properties">
      <div className="container">
        
        {/* Section Header */}
        <div className="section-header-center">
          <span className="premium-subtitle">TYPES OF PROPERTIES WE DEAL WITH</span>
          <h2 className="premium-title">Premium Realty <span className="highlight">Segments</span></h2>
          <div className="gold-divider"></div>
          <p className="premium-desc">
        From residential sanctuaries to industrial powerhouses, we manage a diverse portfolio of high-value assets.
          </p>
        </div>

        {/* The Cinematic Grid */}
        <div className="gallery-grid">
          {PROPERTY_DATA.map((item) => (
            <div key={item.id} className={`gallery-card card-${item.id}`}>
              
              {/* Background Image with Zoom Effect */}
              <div className="bg-image" style={{ backgroundImage: `url(${item.image})` }}></div>
              
              {/* Gradient Overlay */}
              <div className="card-overlay"></div>

              {/* Content Box */}
              <div className="card-content-box">
                <div className="icon-badge">
                  {item.icon}
                </div>
                
                <h3 className="card-title">{item.category}</h3>
                <div className="card-divider"></div>
                <p className="card-details">{item.details}</p>
                
                {/* Reveal on Hover */}
                <p className="card-description">
                  {item.description}
                </p>
              </div>

              {/* Border Accent */}
              <div className="border-accent"></div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PropertyTypes;